import { render, staticRenderFns } from "./Server.vue?vue&type=template&id=faf9ac70&scoped=true"
import script from "./Server.vue?vue&type=script&lang=js"
export * from "./Server.vue?vue&type=script&lang=js"
import style0 from "./Server.vue?vue&type=style&index=0&id=faf9ac70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf9ac70",
  null
  
)

export default component.exports